export const FIGURES = [
  {
    slug: 'richard-iii',
    name: 'Richard III',
    primaryEra: 'late-medieval',
    teaser:
      'The final Yorkist king whose defeat at Bosworth ended the Wars of the Roses and reshaped the crown’s lineage.',
  },
  {
    slug: 'henry-vii',
    name: 'Henry VII',
    primaryEra: 'late-medieval',
    teaser:
      'The first Tudor monarch who united rival houses and cemented new royal power after the Bosworth victory.',
  },
  {
    slug: 'mary-queen-of-scots',
    name: 'Mary, Queen of Scots',
    primaryEra: 'renaissance',
    teaser:
      'A monarch raised in French courts whose return to Edinburgh ignited dynastic crisis and legend within the castle walls.',
  },
  {
    slug: 'saint-aidan',
    name: 'Saint Aidan of Lindisfarne',
    primaryEra: 'early-medieval',
    teaser:
      'Missionary bishop whose journeys from Iona spread monastic learning across Northumbria’s shores.',
  },
  {
    slug: 'aethelflaed',
    name: 'Æthelflæd, Lady of the Mercians',
    primaryEra: 'viking-age',
    teaser:
      'Mercian ruler who fortified towns like York’s borders against Viking pressure and forged alliances with Wessex.',
  },
]
